import { render } from "./MainCustomerOrder.vue?vue&type=template&id=c1a27630&scoped=true"
import script from "./MainCustomerOrder.vue?vue&type=script&lang=js"
export * from "./MainCustomerOrder.vue?vue&type=script&lang=js"

import "./MainCustomerOrder.vue?vue&type=style&index=0&id=c1a27630&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a27630"]])

export default __exports__